// src/components/checkout/OrderSummary.jsx
import React, { useState, useRef } from "react";
import { sanitizeHtml } from "../../utils/sanitize";

export default function OrderSummary({
  originalProductAmount,
  baseProduct,
  subProduct,
  country,
  subtotal,
  shipping,
  total,
  taxes,
  onApplyPromo,
  pricingTier,
  originalMainPrice,
    originalSubPrice,
    mainPriceProductInfo,
    promotekitReferral,
    skipShipping,
    isfreeMemberShip,
    isfreeMemberShipMonthy,
    isfreeAccessory,
    maxUsageReached,
    migratedCust,
    appliedCoupons = [],
    selectedPlan,
    isFreeSid
  }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [discountApplied, setDiscountApplied] = useState(false);
  const [skipSubscription, setSkipSubscription] = useState(false);
  const [isIncompatibleCouponError, setIsIncompatibleCouponError] = useState(false);
  const cartScrollRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Get all free-accessory coupons from applied coupons to determine accessory display
  // Each applied free-accessory coupon renders its own accessory block
  const accessoryCoupons = appliedCoupons.filter(c => c.type === 'free-accessory');
  const getAccessoryImage = (coupon) => coupon?.metadata?.['accessory-image'] || 'accessory_image_game.png';
  const getAccessoryTitle = (coupon) => coupon?.metadata?.['accessory-title'] || 'Limited Edition Chest Strap';
  const getAccessoryDescription = (coupon) => coupon?.metadata?.['accessory-description'] || '';

  // Clear promo code input when max usage is reached
  React.useEffect(() => {
    if (maxUsageReached) {
      setCode("");
      setDiscountApplied(false);
      setSuccess("");
    }
  }, [maxUsageReached]);

  const handleScrollClick = () => {
        if (cartScrollRef.current) {
            const secondProduct = document.getElementById('product-2');
            if (secondProduct) {
                const containerRect = cartScrollRef.current.getBoundingClientRect();
                const productRect = secondProduct.getBoundingClientRect();
                const scrollPosition = cartScrollRef.current.scrollTop + (productRect.top - containerRect.top);
                cartScrollRef.current.scrollTo({ top: scrollPosition, behavior: 'smooth' });
            } else {
                // Fallback: scroll by the height of one product
                cartScrollRef.current.scrollBy({ top: 150, behavior: 'smooth' });
            }
        }
    };
 const formatCurrency = (cents) => {
    const amount = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };
  // format a value in dollars (e.g. 10 -> $10.00)
const formatDollars = (value) => {
  const num = Number(value) || 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
  return (
    <div className="bg-gray-50 p-6 rounded-xl shadow-inner border border-gray-200">
      <h3 className="text-lg font-semibold mb-4">Order Summary</h3>

          <div className="max-h-[600px] overflow-y-auto mb-4 relative scroll-smooth">
                    {/* cart items 1*/}
                    <div id="product-1" className={`flex gap-3 sm:gap-4 p-3 sm:p-4 ${isfreeMemberShip && !maxUsageReached ? 'opacity-50' : ''}`}>
                        {/* Item Image */}
                        <div className="relative flex-shrink-0">
                            <div className="sm:w-16 sm:h-16 w-12 h-12 rounded-xl bg-[#ededed] border-2 border-white flex items-center justify-center overflow-hidden">
                                <img src="img_1.png" alt="Logo" className="w-full h-full object-cover p-0.5 rounded-xl" />
                            </div>
                            {/* Quantity Badge */}
                            <div className="absolute -top-1 -right-1 min-w-5 min-h-5 sm:min-w-6 sm:min-h-6 bg-black text-white rounded-md flex items-center justify-center text-xs font-semibold">
                                1
                            </div>
                        </div>
                        {/* Item Details */}
                        <div className="flex-1 min-w-0">
                            <h3 className={`text-sm sm:text-base font-medium smb-0.5 transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}>
                                Founding Membership
                            </h3>
                            <p className={`text-xs mb-0.5 transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}>
                                {isFreeSid && selectedPlan === "yearly" ? "Annually Subscription" : "Monthly Subscription"}
                            </p>

                             {migratedCust !== "migrated_cust" && (
                             <p className={`text-xs mb-0.5 transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}>
                                Membership starts only when you receive the product.
                             </p>
                            )}

                            {migratedCust === "migrated_cust" && (
                              <p className={`pt-2 pl-3 text-xs text-xs mb-0.5 transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}>
                               <li> <strong>No changes</strong> to your existing Monthly Membership.</li>
                              </p>
                            )}
                            
                            {migratedCust === "migrated_cust" && (
                              <p className={`pt-1 pl-3 text-xs mb-0.5 transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}>
                               <li> There is no <strong>monthly commitment</strong> applied to Gen-2 upgrade. If you decide to end your membership in less than 90 days, please return your hardware to us.</li>
                              </p>
                            )}
                                {pricingTier === "standard" && (
                              <p className="text-xs mb-1 transition-colors">
                                Info: 6 Months Commitment.
                              </p>
                                )}
                                    {pricingTier !== "free" && (
                                    <p className={`text-xs mb-2 leading-relaxed transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : ''}`}>
                                        Access To: Get access to Full Session Tracking, Work Volume, Power Score, and Efficiency Metrics before anyone else. Train smarter, not harder.
                                    </p>
                                )}
                        </div>
                        <div className="">
                            {pricingTier === "free" ? (
                                <>
                                {isFreeSid && selectedPlan === "yearly" && originalSubPrice ? (
                                    <p className={`text-sm sm:text-base font-bold transition-colors text-black line-through ${isfreeMemberShip && !maxUsageReached ? 'text-gray-400' : ''}`}>
                                        {formatCurrency(originalSubPrice)}
                                    </p>
                                ) : (
                                    <p className={`text-sm sm:text-base font-bold transition-colors text-black line-through ${isfreeMemberShip && !maxUsageReached ? 'text-gray-400' : ''}`}>
                                        {migratedCust === "migrated_cust" ? "$15.00" : "$19.00"}
                                    </p>
                                )}
                                <p className={`text-sm sm:text-base font-bold transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}> 
                                    {formatCurrency(subProduct)}                              
                                </p>
                                </>
                            ) : (
                                <>
                                <p className={`text-sm sm:text-base font-bold transition-colors text-black ${skipSubscription ? 'line-through' : ''} ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : ''}`}> 
                                    {formatCurrency(subProduct)}                              
                                </p>
                                {pricingTier === "standard" && originalSubPrice && subProduct < originalSubPrice && !skipSubscription && (
                                    <p className="text-sm sm:text-base font-bold transition-colors text-black line-through">
                                    {formatCurrency(originalSubPrice)}
                                    </p>
                                )}
                                </>
                            )}
                        </div>
                    </div>
                    {/* cart items 2*/}
                    <div id="product-2" className="flex gap-3 sm:gap-4 p-3 sm:p-4">
                        {/* Item Image */}
                        <div className="relative flex-shrink-0">
                            <div className="sm:w-16 sm:h-16 w-12 h-12 rounded-xl bg-[#ededed] border-2 border-white flex items-center justify-center overflow-hidden">
                                <img src={mainPriceProductInfo?.productImage || "full_system.png"} alt="Logo" className="w-full h-full object-cover p-0.5 rounded-xl" />
                            </div>
                            {/* Quantity Badge */}
                            <div className="absolute -top-1 -right-1 min-w-5 min-h-5 sm:min-w-6 sm:min-h-6 bg-black text-white rounded-md flex items-center justify-center text-xs font-semibold">
                                1
                            </div>
                        </div>
                        {/* Item Details */}
                        <div className="flex-1 min-w-0">
                            <h3 className="text-sm sm:text-base font-medium text-black smb-0.5 transition-colors">
                                {mainPriceProductInfo?.productTitle || "WurQ System"}
                            </h3>
                            {mainPriceProductInfo?.productDescription ? (
                              <p
                                className="text-xs mb-1 transition-colors text-black [&_p]:mb-1"
                                dangerouslySetInnerHTML={{ __html: sanitizeHtml(mainPriceProductInfo.productDescription) }}
                              />
                            ) : (
                              <p className="text-xs mb-1 transition-colors">
                                Includes: Wrist + chest wearables
                              </p>
                            )}
                            {pricingTier !== "free" && (
                              <p className="text-xs mb-2 leading-relaxed transition-colors">
                                Access To: Experience automatic movement detection that tracks every rep, round, rest, and transition seamlessly, while monitoring your heart rate by movement and more.
                              </p>
                            )}
                        </div>
                        <div className="">
                             {pricingTier === "free" ? (
                               <>
                                 <p className="text-sm sm:text-base font-bold transition-colors text-black line-through">
                                   {originalMainPrice ? formatCurrency(originalMainPrice) : formatCurrency(baseProduct)}
                                 </p>
                                 <p className="text-sm sm:text-base font-bold transition-colors text-green-600">
                                   Free
                                 </p>
                               </>
                             ) : (
                              <>
                                <p className="text-sm sm:text-base font-bold transition-colors text-black">
                                  {formatCurrency(baseProduct)}
                                </p>
                                {originalMainPrice && baseProduct < originalMainPrice && (
                                  <p className="text-sm sm:text-base font-bold transition-colors text-black line-through">
                                    {formatCurrency(originalMainPrice)}
                                  </p>
                                )}
                              </>
                            )}
                        </div>
                    </div>



                     {/* free accessories - one block per applied free-accessory coupon */}
                    {isfreeAccessory && accessoryCoupons.length > 0 && (
                        <>
                            <div className="flex items-center justify-center gap-2 px-3 sm:px-4 pt-2">
                                <svg className="w-4 h-4 text-black flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                </svg>
                                <span className="text-xs sm:text-sm font-medium text-black">Free Accessory</span>
                            </div>
                            {accessoryCoupons.map((coupon, idx) => {
                                const accImage = getAccessoryImage(coupon);
                                const accTitle = getAccessoryTitle(coupon);
                                const accDescription = getAccessoryDescription(coupon);
                                return (
                                    <div key={coupon.code || idx} id={`product-${3 + idx}`} className="flex gap-3 sm:gap-4 p-3 sm:p-4">
                                        {/* Item Image */}
                                        <div className="relative flex-shrink-0">
                                            <div className="sm:w-16 sm:h-16 w-12 h-12 rounded-xl bg-[#ededed] border-2 border-white flex items-center justify-center overflow-hidden">
                                                <img src={accImage} alt="Logo" className="w-full h-full object-cover p-0.5 rounded-xl" />
                                            </div>
                                            {/* Quantity Badge */}
                                            <div className="absolute -top-1 -right-1 min-w-5 min-h-5 sm:min-w-6 sm:min-h-6 bg-black text-white rounded-md flex items-center justify-center text-xs font-semibold">
                                                1
                                            </div>
                                        </div>
                                        {/* Item Details */}
                                        <div className="flex-1 min-w-0">
                                            <h3 className="text-sm sm:text-base font-medium text-black smb-0.5 transition-colors">
                                                {accTitle}
                                            </h3>
                                            {accDescription && (
                                                <p className="text-xs mb-1 transition-colors">
                                                    {accDescription}
                                                </p>
                                            )}
                                        </div>
                                        <div className="">
                                            {/* {pricingTier === "free" && (
                                                    <p className="text-sm sm:text-base font-bold transition-colors text-black line-through">
                                                        free
                                                    </p>
                                            )} */}
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                    

                    {/* Discount Code Section */}
                    <div className={`mt-4 mx-3 sm:mx-4 p-3 sm:p-4 bg-white rounded-lg border border-gray-200 shadow-sm ${maxUsageReached ? 'opacity-50' : ''}`}>
                        <h4 className="text-sm sm:text-base font-semibold text-black mb-3">Have a discount code?</h4>
                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="text"
                                value={code}
                                onChange={(e) => {
                                    if (maxUsageReached || isIncompatibleCouponError) return; // Prevent changes when incompatible error
                                    setCode(e.target.value);
                                    setError(""); // Clear error when typing
                                    setSuccess(""); // Clear success when typing
                                    setDiscountApplied(false); // Reset discount applied state
                                    setIsIncompatibleCouponError(false); // Reset incompatible flag when typing
                                }}
                                placeholder="Enter discount code"
                                className="flex-1 px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent transition-all"
                                disabled={loading || maxUsageReached || isIncompatibleCouponError}
                            />
                            <button
                                onClick={async () => {
                                    if (maxUsageReached || isIncompatibleCouponError) return;
                                    const promoCode = code.trim();
                                    if (!promoCode) {
                                        setError("Please enter a discount code");
                                        setSuccess("");
                                        setCode("");
                                        return;
                                    }
                                    if (!onApplyPromo) {
                                        setError("Promo code is not available right now.");
                                        setSuccess("");
                                        setCode("");
                                        setDiscountApplied(false);
                                        return;
                                    }
                                    try {
                                        setLoading(true);
                                        setError("");
                                        setSuccess("");
                                        // Send combined list of existing applied coupons + new coupon code
                                        const allPromoCodes = [...appliedCoupons.map(c => c.code), promoCode];
                                        const result = await onApplyPromo({ promoCodes: allPromoCodes });
                                        if (result?.success === true) {
                                            if (result?.data?.maxUsageReached) {
                                                setError("This coupon has reached its maximum usage");
                                                setSuccess("");
                                                setDiscountApplied(false);
                                                setCode("");
                                            } else {
                                                const isFreeMember = result?.data?.isfreeMemberShip;
                                                const isFreeMemberMonthly = result?.data?.isfreeMemberShipMonthy;
                                                const successMsg = isFreeMemberMonthly
                                                    ? `Congrats, you have unlocked ${result?.data?.NoOfMonths} months of free subscription`
                                                    : isFreeMember
                                                        ? "Congrats, you have unlocked the free subscription"
                                                        : (result?.data?.message || result?.message || "✅ Discount code applied successfully");
                                                setSuccess(successMsg);
                                                setError("");
                                                setDiscountApplied(false);
                                                setCode(""); // Reset input field after successful application
                                                // Check for skip_subscription metadata
                                                const promoMetadata = result?.data?.promoMetadata || result?.promoMetadata || "";
                                                setSkipSubscription(promoMetadata === "skip_subscription");
                                            }
                                        } else if (result?.success === false) {
                                            const apiMessage =
                                                result?.error?.response?.data?.message ||
                                                result?.error?.response?.data?.error ||
                                                result?.error?.message ||
                                                "Invalid or expired discount code.";
                                            setError(apiMessage);
                                            setSuccess("");
                                            setCode("");
                                            setDiscountApplied(false);
                                            setSkipSubscription(false);
                                            // Check if this is an incompatible coupon error AND we already have 2 coupons
                                            const errorCode = result?.error?.response?.data?.code || result?.error?.data?.code;
                                            const isIncompatible = errorCode === "INCOMPATIBLE_COUPONS";
                                            // Only disable input if we have 2 coupons and trying to add incompatible third
                                            setIsIncompatibleCouponError(isIncompatible && appliedCoupons.length >= 2);
                                            // Don't clear existing coupons - keep them applied
                                        }
                                    } catch (err) {
                                        setError("Failed to apply discount code.");
                                        setSuccess("");
                                        setCode("");
                                        setDiscountApplied(false);
                                        setSkipSubscription(false);
                                        setIsIncompatibleCouponError(false);
                                        // Don't clear existing coupons - keep them applied
                                    } finally {
                                        setLoading(false);
                                    }
                                }}
                                disabled={loading || !code.trim() || maxUsageReached || isIncompatibleCouponError}
                                className="px-4 sm:px-6 py-2 bg-black text-white text-sm sm:text-base font-medium rounded-lg hover:bg-gray-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
                            >
                                {loading ? "Applying..." : "Apply"}
                            </button>
                        </div>
                        {error && (
                            <span className="block mt-2 text-xs sm:text-sm text-red-600 font-medium">
                                {error}
                            </span>
                        )}
                        {maxUsageReached && (
                            <span className="block mt-2 text-xs sm:text-sm text-red-600 font-medium">
                                This coupon has reached its maximum usage
                            </span>
                        )}
                        {success && !maxUsageReached && (
                            <span className="block mt-2 text-xs sm:text-sm text-green-600 font-medium">
                                Coupon code applied successfully
                            </span>
                        )}
                        {/* Applied Coupons List - show coupon name and remove button, no amount */}
                        {appliedCoupons.length > 0 && (
                            <div className="mt-3 space-y-2">
                                {appliedCoupons.map((coupon, index) => (
                                    <div key={index} className="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg px-3 py-2">
                                        <div className="flex items-center gap-2">
                                            <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                            <span className="text-sm font-medium text-green-800">{coupon.code}</span>
                                        </div>
                                        <button
                                            onClick={async () => {
                                                setLoading(true);
                                                setError("");
                                                setSuccess("");
                                                setIsIncompatibleCouponError(false); // Reset incompatible flag when removing coupon
                                                // Remove this specific coupon and re-send remaining
                                                const remainingCoupons = appliedCoupons.filter((_, i) => i !== index);
                                                if (onApplyPromo) {
                                                    const result = await onApplyPromo({ promoCodes: remainingCoupons.map(c => c.code) });
                                                    // Reset local flags based on result
                                                    if (result?.success) {
                                                        const data = result?.data || {};
                                                        const isFreeMember = data?.isfreeMemberShip;
                                                        const promoMetadata = data?.promoMetadata || "";
                                                        setSkipSubscription(promoMetadata === "skip_subscription");
                                                        setDiscountApplied(false);
                                                    }
                                                }
                                                setLoading(false);
                                            }}
                                            className="text-green-600 hover:text-green-800 transition-colors"
                                            disabled={loading}
                                        >
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Scroll Indicator Button - Only show if there are multiple products */}
                    {showScrollButton && (
                        <button 
                            onClick={handleScrollClick}
                            className="absolute bottom-0 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded-full text-xs sm:text-sm font-medium transition-colors bg-[#666666] text-white border border-gray-200 z-10"
                        >
                            Scroll for more items ↓
                        </button>
                    )}
                </div>
                <div className="">
            <div className="rounded-lg border p-4 sm:p-5 transition-colors">
                {/* Order Summary Details */}
                <div className="space-y-3">
                    {/* Shipping */}
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-1">
                            <span className={`text-xs sm:text-base transition-colors text-black${(promotekitReferral || skipShipping) ? ' line-through' : ''}`}>
                                Shipping
                            </span>
                            <div className="relative group">
                                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-black cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 px-3 py-2 bg-black text-white text-xs sm:text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg w-48 text-left">
                                    This is the shipping cost charged by our carrier to deliver the WurQ system from our warehouse to your address
                                    <div className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-r-black border-t-transparent border-b-transparent border-l-transparent"></div>
                                </div>
                            </div>
                        </div>
                        <span className={`text-xs sm:text-base transition-colors text-[#0D192E]${(promotekitReferral || skipShipping) ? ' line-through' : ''}`}>
                            {formatCurrency(shipping)}
                        </span>
                    </div>
                    <div className="flex justify-between items-center">
                        <p className="text-sm sm:text-base transition-colors text-black">
                            Taxes
                        </p>
                        <div className="flex items-center gap-2">
                            <span className="text-xs sm:text-base font-semibold transition-colors text-black">
                                {formatCurrency(taxes)}
                            </span>
                        </div>
                    </div>
                    {/* Total */}
                    <div className="flex justify-between items-center pt-3">
                        <div>
                            <span className="text-sm sm:text-base font-semibold block transition-colors text-black">
                                Total
                            </span>
                        </div>
                        <div className="flex items-center gap-1">
                            <span className="text-xs transition-colors text-[#0D192E]">
                                
                            </span>
                            <span className="text-lg sm:text-xl font-bold transition-colors text-black">
                                {formatCurrency(total)}
                            </span>
                        </div>

                    </div>
                    {/* Recurring Subtotal */}
                    <div className={`flex justify-between items-center pt-3 border-t border-gray-200 ${isfreeMemberShip && !maxUsageReached ? 'opacity-50' : ''}`}>
                        <div className="flex items-center gap-1">
                            <span className={`text-xs sm:text-base transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : 'text-black'}`}>
                                Recurring subtotal
                            </span>
                            <div className="relative group">
                                <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-black cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div className="absolute left-full ml-2 top-1/2 transform -translate-y-1/2 px-3 py-2 bg-black text-white text-xs sm:text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none shadow-lg w-48 text-left">
                                    {isFreeSid && selectedPlan === "yearly"
                                        ? "This is the annual subscription fee. Billing starts once your WurQ system has been delivered. The subscription includes a 12-month commitment, after which you can cancel anytime."
                                        : "This is the monthly subscription fee. Billing starts once your WurQ system has been delivered. The subscription includes a 6-month commitment, after which you can cancel anytime."}
                                    <div className="absolute right-full top-1/2 transform -translate-y-1/2 border-4 border-r-black border-t-transparent border-b-transparent border-l-transparent"></div>
                                </div>
                            </div>
                        </div>
                        {isFreeSid && selectedPlan === "yearly" && originalSubPrice ? (
                            <div className="flex items-center gap-1">
                                <span className="text-xs sm:text-base font-semibold transition-colors line-through text-gray-400">
                                    {/* {formatCurrency(originalSubPrice)} */}
                                </span>
                                <span className="text-xs sm:text-base font-semibold transition-colors text-black">
                                    {formatCurrency(subProduct)} / year
                                </span>
                            </div>
                        ) : (
                            <span className={`text-xs sm:text-base font-semibold transition-colors ${isfreeMemberShip && !maxUsageReached ? 'line-through text-gray-400' : ''}`}>
                               {formatCurrency(subProduct)} / month
                            </span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}
